import React from 'react';
import {bool, func, node, oneOfType} from 'prop-types';

function isEmptyChildren (children) {
  return React.Children.count(children) === 0;
}

const propTypes = {
  children  : oneOfType([func, node]),
  condition : oneOfType([bool, func]),
  otherwise : func,
  render    : func
};

const defaultProps = {
  children  : null,
  condition : false,
  otherwise : () => null
};

const displayName = 'If';

// eslint-disable-next-line complexity
const If = props => {
  const {children, component, condition, otherwise, render} = props;
  const evaluatedCondition = typeof condition === 'function' ? condition() : Boolean(condition);

  if (evaluatedCondition) {
    if (component) {
      return React.createElement(component);
    }

    if (render) {
      return render();
    }

    if (children) {
      if (typeof children === 'function') {
        return children();
      }

      return isEmptyChildren(children) ? null : React.Children.only(children);
    }

    return null;
  }

  return otherwise();
};

If.displayName = displayName;
If.propTypes = propTypes;
If.defaultProps = defaultProps;

export default If;
